import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import M from "materialize-css";

import { useAuth } from "../hooks/usehooks.com/use-auth";

import cavsLogo from "../../public/img/cavs-logo.png";

const successMsg =
  "Password reset email sent successfully! Please allow up to 5 minutes.";
const errorMsg =
  "There was an error resetting your password, please contact help.";

export default function Forgot() {
  const auth = useAuth();
  const [email, setEmail] = useState("");
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await auth.sendPasswordResetEmail(email);
      M.toast({ html: successMsg });
    } catch (err) {
      M.toast({ html: errorMsg });
    }
  };

  useEffect(() => {
    if (auth.user) {
      navigate("/my");
    }
  }, [auth.user]);

  return (
    <div className="container login-container">
      <div className="card-panel login-panel">
        <div className="login-title dark-primary-color">
          <div className="row">
            <div className="col s12 text-center">
              <img
                src={`/${cavsLogo}`}
                alt="CAVS logo"
                className="login-logo"
              />
            </div>
          </div>
          <div className="row">
            <div className="col s12">
              <span className="white-text login-title">
                Cost Analysis Valuation System
              </span>
            </div>
          </div>
        </div>
        <div className="row vertical-padding">
          <div className="col m8 offset-m2">
            <div className="row">
              <div className="col">
                <p>
                  <span className="secondary-text-color">
                    Reset your CAVS password by entering your email.
                  </span>
                </p>
              </div>
            </div>
            <div className="row">
              <form className="col s12">
                <div className="row">
                  <div className="input-field col s12">
                    <input
                      onChange={(e) => setEmail(e.target.value)}
                      value={email}
                      id="email"
                      type="email"
                      className="validate text-lowercase"
                    />
                    <label htmlFor="email">Email</label>
                  </div>
                </div>
                <div className="row">
                  <div className="col m12">
                    <p className="text-center">
                      <button
                        onClick={handleSubmit}
                        className="btn btn-sm default-primary-color"
                      >
                        Request Reset
                      </button>
                    </p>
                  </div>
                </div>
                <div className="row">
                  <div className="col">
                    <p className="text-center">
                      <span className="helper-text">
                        For the best experience using CAVS, we recommend using
                        the latest version of Chrome.
                      </span>
                    </p>
                  </div>
                </div>
                <div className="row">
                  <div className="col m12 text-center">
                    <Link to="/login" className="secondary-text-color">
                      &laquo; Login
                    </Link>
                  </div>
                </div>
                <div className="row">
                  <div className="col m12 text-center">
                    <a href="/" className="secondary-text-color">
                      Home
                    </a>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
